import {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'

export const reposListAppBuilder = DataRouterApplicationBuilder.create('repos-list')
